var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#138e16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f7f12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed2b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d91b25"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.4285714h5.33333333v-3.80952378h10.66666667v-3.80952381h-10.66666667v-3.80952381h-5.33333333z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.66666667 2.69243314-.66115618.96618609.34317058-1.11931989-1.16761884.08549447 1.08908287-.42958298-.79484069-.85957624 1.01489356.58363867.1764687-1.1573685.17646869 1.1573685 1.01489356-.58363867-.79484069.85957624 1.08908287.42958298-1.16761883-.08549447.34317057 1.11931989z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.333333 0h10.666667v3.809524h-10.666667z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/OM.63d3e499f985d671209253284a2edfc5.svg";
export { ForwardRef as ReactComponent };